<script lang="ts" setup>
import { ScalarFormSection } from '@scalar/components'
import type { ExternalUrls } from '@scalar/types/api-reference'
import type { WorkspaceStore } from '@scalar/workspace-store/client'

import { useI18n } from '@/i18n'
import ApiReferenceToolbarPopover from './ApiReferenceToolbarPopover.vue'
import ApiReferenceToolbarShareRegister from './ApiReferenceToolbarShareRegister.vue'

const { workspace, externalUrls } = defineProps<{
  workspace: WorkspaceStore
  externalUrls: ExternalUrls
}>()

const { t } = useI18n()
</script>

<template>
  <ApiReferenceToolbarPopover class="w-120">
    <template #label>{{ t('developerTools.deploy') }}</template>
    <ScalarFormSection>
      <template #label>{{ t('developerTools.scalarDocs') }}</template>
      <p class="text-c-2 mb-2 leading-normal">
        {{ t('developerTools.deployDescription') }}
      </p>
      <ApiReferenceToolbarShareRegister
        :externalUrls
        :workspace />
    </ScalarFormSection>
  </ApiReferenceToolbarPopover>
</template>
